import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  font-size: 160px;
  opacity: 0.9;
  color: white;
  font-family: 'Galano Classic';
  font-weight: 400;

  ${media.medium`
    font-size: 16.4vw;
    line-height: 240px;
    margin-bottom: -30px;
  `}
`;
